import ApplicationRecord from './ApplicationRecord';
/**
 * Home page.
 *
 *
 */
export default class NewOfferPage
  extends ApplicationRecord({
    /**
   * @type {Number}
   */
    ID: -1,
    /**
     * @type {String}
     */
    Path: '',
    /**
     * Absolute path.
     * @type {String}
     */
    URL: '',
    /**
     * @type {String}
     */
    Title: '',
    /**
     * @type {Boolean}
     */
    ShowInMenus: false,
    /**
     * @type {Object}
     */
    _embedded: {},
  }) {}



// WEBPACK FOOTER //
// ./src/models/NewOfferPage.js